import classnames from 'classnames';
import styles from './index.module.scss';
function Skeleton() {
  return <div className={classnames(styles['carousel-wrapper'], 'carousel-parent skeleton-section')} data-sentry-component="Skeleton" data-sentry-source-file="CarouselButtonsSkeleton.tsx">
   <div className="buttons-skeleton skeleton-loading"></div>
  </div>;
}
export default Skeleton;